import { Link } from 'react-router-dom'
import MediaActionButton from '../../common/MediaActionButton'
import { getServiceLinks, renderServiceLinksWithSeparators } from '../utils/serviceLinks'
import { getWeekStart, formatWeekLabel } from '../../../utils/uiHelpers'
import DateBreak from './DateBreak'

function MediaList({
  mediaItems,
  onRemoveFromCollection,
  onAddToCollage,
  type,
  removeLoadingStates = {},
  showNoteText = false,
  showRecInfo = false,
}) {
  const renderArtists = (item) => {
    if (
      !item.primary_artists ||
      !item.primary_artists.length ||
      type === 'playlist' ||
      type === 'mix'
    ) {
      return null
    }

    return (
      <>
        <span className='metadata-text secondary'> by </span>
        {item.primary_artists
          .map((artist) => (
            <Link
              key={artist.id}
              to={`/artist/${artist.id}`}
              className='metadata-text primary interactive'
            >
              {artist.name}
            </Link>
          ))
          .reduce((prev, curr, index) => [prev, <span key={`separator-${index}`}>, </span>, curr])}
      </>
    )
  }

  const renderMetadata = (item) => {
    if (type === 'playlist' && item.song_count) {
      return <span className='metadata-text secondary'> ({item.song_count} songs)</span>
    }
    return null
  }

  const renderNoteText = (item) => {
    if (showNoteText && item.note_text) {
      return (
        <div className='note-text'>
          <span className='metadata-text secondary'>Note: </span>
          <span className='note-content'>{item.note_text}</span>
        </div>
      )
    }
    return null
  }

  const renderRecInfo = (item) => {
    if (showRecInfo && item.from_user) {
      return (
        <div className='rec-info'>
          <span className='metadata-text secondary'>Recommended by: </span>
          <span className='rec-user'>{item.from_user}</span>
          {item.message && (
            <>
              <span className='metadata-text secondary'> — </span>
              <span className='rec-message'>"{item.message}"</span>
            </>
          )}
        </div>
      )
    }
    return null
  }

  // Sort and filter items, then add date breaks between weeks
  const sortedItems = mediaItems
    .sort(
      (a, b) =>
        new Date(b.added_at || b.updated_at || 0) - new Date(a.added_at || a.updated_at || 0)
    )
    .filter((item) => type !== 'album' || item.direct_add)

  // Build list with date breaks
  const renderItemsWithDateBreaks = () => {
    const elements = []
    let lastWeekKey = null

    sortedItems.forEach((item) => {
      const itemDate = item.added_at || item.updated_at
      if (itemDate) {
        const weekStart = getWeekStart(itemDate)
        const weekKey = weekStart.getTime()

        if (weekKey !== lastWeekKey) {
          elements.push(<DateBreak key={`week-${weekKey}`} label={formatWeekLabel(weekStart)} />)
          lastWeekKey = weekKey
        }
      }

      elements.push(
        <li key={item.id + (item.note_id || item.rec_id || '')}>
          <div className='metadata'>
            <Link
              to={`/${item.type || type}/${item.id}`}
              className='metadata-text primary interactive'
            >
              {item.title}
            </Link>
            {renderArtists(item)}
            {renderMetadata(item)}
            {renderNoteText(item)}
            {renderRecInfo(item)}
            {type !== 'collage' && (
              <div className='service-links'>
                {renderServiceLinksWithSeparators(getServiceLinks(item, item.type || type))}
              </div>
            )}
          </div>
          <div className='media-actions'>
            <MediaActionButton
              onClick={(event) => onAddToCollage(item.type || type, item.id, event)}
              isActive={false}
              isLoading={false}
              actionType='Collage'
            />
            <MediaActionButton
              onClick={() => onRemoveFromCollection(item.type || type, item.id)}
              isActive={false}
              isLoading={removeLoadingStates[item.id]}
              actionType='Remove'
            />
          </div>
        </li>
      )
    })

    return elements
  }

  return (
    <div className='centered-list'>
      <ul className='left-justify'>{renderItemsWithDateBreaks()}</ul>
    </div>
  )
}

export default MediaList
